/* eslint-disable react/destructuring-assignment */
import React from 'react';

import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import LoadingIcon from '@/assets/icons/Loading.gif';

import './LoadingVolumeSensorGraph.less';

function LoadingVolumeSensorGraph(props) {
  const fontSize = useSelector((state) => state.setupStore.fontSize);
  return (
    <div
      className="loadingChartIcon center"
      style={{fontSize}}
    >
      <div>
        <div className="center">
          <img
            src={LoadingIcon}
            alt={LoadingIcon}
          />{' '}
          &nbsp;
        </div>
        <div className="center">
          <span>{props.text}</span>
        </div>
      </div>
    </div>
  );
}
LoadingVolumeSensorGraph.propTypes = {
  text: PropTypes.string.isRequired,
};
export default LoadingVolumeSensorGraph;
